<template>
  <global-forms id="forms"></global-forms>
</template>

<script>
  import { GlobalManager } from '@/components/home/controllers/global'
  import Forms from '@/components/home/forms'

  export default {
    data () {
      return {}
    },
    async created () {
      this._globalManager = new GlobalManager(this)

      this._imported = () => {
        this._globalManager.editBasicConfig()
      }

      this.$emitter.on('imported', this._imported)
      this._globalManager.editBasicConfig()
    },
    components: {
      'global-forms': Forms
    },
    methods: {
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/home/tabs/basic.vue